import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

import { Text } from "./Text.tsx";

export const DialogDescription = ({
  className,
  ...props
}: { className?: string } & Omit<
  Headless.DescriptionProps<typeof Text>,
  "as" | "className"
>): ReactElement => (
  <Headless.Description
    as={Text}
    {...props}
    className={clsx(className, "mt-2 text-pretty")}
  />
);
